var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM9.84615 14.1538C9.84615 14.6212 9.46732 15 9 15C8.53268 15 8.15385 14.6212 8.15385 14.1538C8.15385 13.6865 8.53268 13.3077 9 13.3077C9.46732 13.3077 9.84615 13.6865 9.84615 14.1538ZM9 3.15385C7.13073 3.15385 5.61538 4.66919 5.61538 6.53846H7.30769C7.30769 5.60383 8.06536 4.84615 9 4.84615H9.0798C9.97036 4.84615 10.6923 5.5681 10.6923 6.45866V6.89288C10.6923 7.32765 10.4141 7.71363 10.0017 7.85111C8.89816 8.21894 8.15385 9.25163 8.15385 10.4148V12.4615H9.84615V10.4148C9.84615 9.98005 10.1244 9.59406 10.5368 9.45658C11.6403 9.08875 12.3846 8.05607 12.3846 6.89288V6.45866C12.3846 4.63347 10.905 3.15385 9.0798 3.15385H9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.7a2a21531d76037b1c1b4e08861bb631.svg";
export { ForwardRef as ReactComponent };